import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import InfoBlockData from '../../../Models/Content/InfoBlockData';
import InfoBlock from './InfoBlock.js';

export default class InfoBlockComponent extends EpiComponent<InfoBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <InfoBlock context={this.getContext()} iContent={this.props.data} />;
  }
}

